import { memo } from "react";
import { styled } from "styled-components";

import { UITag } from "common/components";
import { ListItemWrapper } from "common/components/lists/ListItemWrapper";
import { ListImage, ListLink } from "common/components/lists/ListLink";
import { breakWordStyle, lineTruncationStyle } from "common/styles";
import type { EventSession } from "entities/events/types";

const StyledListLink = styled(ListLink)`
  display: flex;
  align-items: center;
`;

const StyledTitle = styled.div`
  font-weight: 500;
  font-size: 1rem;
  margin: 0;
  margin-top: 5px;

  ${breakWordStyle}

  ${lineTruncationStyle(2)}
`;

const StyledSubtitle = styled.div`
  font-size: 0.9rem;
  margin: 0;
  margin-top: 5px;

  ${breakWordStyle}

  ${lineTruncationStyle(2)}
`;

const StyledImage = styled(ListImage)`
  border-radius: 4px;
  margin-right: 1rem;
  height: 80px;
  width: 80px;
  min-width: 80px;
`;

const StyledTag = styled(UITag)`
  font-size: 0.9rem;
`;

type EventListItemProps = { event: EventSession; isSelected?: boolean; link: string; onClick?: () => void };

export const EventListItem = memo(({ isSelected = false, link, onClick, event }: EventListItemProps) => {
  const { name, images } = event;

  return (
    <ListItemWrapper trackPage="Discover" isSelected={isSelected} isLocked={false}>
      <StyledListLink to={link} onClick={onClick}>
        <StyledImage src={images?.thumbnail} />
        <div>
          <StyledSubtitle>{event.event}</StyledSubtitle>
          <StyledTitle>{name}</StyledTitle>
          <StyledTag>{event.type}</StyledTag>
        </div>
      </StyledListLink>
    </ListItemWrapper>
  );
});

EventListItem.displayName = "EventListItem";
